import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { BiX, BiMenu } from "react-icons/bi";
import "./navbar.css";
import logoImg from "../../assets/Logo.png";

const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(true);
  const [isTop, setIsTop] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();

  const handlePageNav = (path) => {
    setIsMenuOpen(false);
    navigate(path);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const controlNavbar = () => {
      const currentScrollY = window.scrollY;
      setIsTop(currentScrollY < 50);
      if (currentScrollY > lastScrollY && currentScrollY > 100) setShowNavbar(false);
      else setShowNavbar(true);
      setLastScrollY(currentScrollY);
    };
    window.addEventListener("scroll", controlNavbar);
    return () => window.removeEventListener("scroll", controlNavbar);
  }, [lastScrollY]);

  return (
    <nav className={`custom-navbar ${showNavbar ? "navbar-visible" : "navbar-hidden"} ${isTop ? "at-top" : "scrolled"}`}>
      <div className="navbar-main-container">
        {/* Floating Pill for Desktop */}
        <div className="navbar-floating-pill d-none d-lg-flex">
          <Link to="/" onClick={() => handlePageNav("/")} className="navbar-logo-wrapper">
            <img src={logoImg} alt="Dazbog" className="logo-img" />
          </Link>

          <div className="navbar-links-center">
            <NavLink to="/" className="nav-item-link" onClick={() => handlePageNav("/")}>Home</NavLink>
            <Link to="#" className="nav-item-link" onClick={(e) => e.preventDefault()}>About</Link>
            <Link to="#" className="nav-item-link" onClick={(e) => e.preventDefault()}>Services</Link>
            <Link to="#" className="nav-item-link" onClick={(e) => e.preventDefault()}>Projects</Link>
            <NavLink to="/contact" className="nav-item-link" onClick={() => handlePageNav("/contact")}>Contact</NavLink>
          </div>

          <div className="navbar-cta-right">
            <button className="navbar-contact-btn" onClick={() => handlePageNav("/contact")}>
              Contact Us
            </button>
          </div>
        </div>

        {/* Standard Mobile Navbar (Keeps old behavior as requested) */}
        <div className="mobile-navbar-row d-flex d-lg-none w-100 justify-content-between align-items-center">
          <Link to="/" onClick={() => handlePageNav("/")}>
            <img src={logoImg} alt="Dazbog" className="logo-img" />
          </Link>
          <button className="navbar-toggler border-0" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <BiX size={35} /> : <BiMenu size={35} />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer (Designs Unchanged) */}
      <div className={`mobile-drawer-wrapper d-lg-none ${isMenuOpen ? "show" : ""}`}>
        <div className="mobile-drawer-header">
          <img src={logoImg} alt="Dazbog" className="logo-img" />
          <BiX size={35} onClick={() => setIsMenuOpen(false)} />
        </div>
        <div className="mobile-inner-content">
          <NavLink to="/" onClick={() => handlePageNav("/")}>Home</NavLink>
          <Link to="#" onClick={(e) => e.preventDefault()}>About Us</Link>
          <Link to="#" onClick={(e) => e.preventDefault()}>Services</Link>
          <Link to="#" onClick={(e) => e.preventDefault()}>Careers</Link>
          <NavLink to="/contact" onClick={() => handlePageNav("/contact")}>Contact</NavLink>
          <div className="mt-4 pb-4">
            <button 
              className="navbar-contact-btn w-100" 
              onClick={() => handlePageNav("/contact")}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;